import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: { display: "flex" },
  title: { color: theme.palette.primary.main, marginBottom: theme.spacing(7) },
  image: {
    width: "100%",
    height: "100vh",
    overflow: "hidden",
    backgroundImage:
      "url(https://datasalesio-imagens.s3.amazonaws.com/tmp/capa_app.png)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
  LoginMaskImg: { height: "100vh", backgroundColor: "rgba(54, 50, 94, 0.2)" },
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: { margin: theme.spacing(3, 0, 2) },
  retrieveAccount: { marginTop: `${theme.spacing(2)} !important` },
  progress: {
    color: "#fff",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));
